import { FormBase } from 'core/components';
import validatorjs from 'validatorjs';

export default class WarehouseEditForm extends FormBase {
	constructor(hooks) {
		super(hooks);
		this.setForm(this);
	}
	setup() {
		var Validator = validatorjs;
		Validator.register(
			'password',
			value => {
				return value.trim().match(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(^.{12,}$)/);
			},
			'PASSWORDMINREQUIREMENTS'
		);
		Validator.register(
			'time',
			value => {
				var res = value.split(':');
				var hours = false;
				var minutes = false;
				if (!res[0].includes('H') && res[0] <= 23) {
					hours = true;
					if (!res[1].includes('m') && res[1] <= 59) {
						minutes = true;
					}
				}
				if (hours && minutes) {
					return true;
				}
				return false;
			},
			'INVALIDTIME'
		);
		Validator.register(
			'phone',
			value => {
				return value.match(/[a-z]/i) ? false : true;
			},
			'INVALIDPHONEFORMAT'
		);
		Validator.register(
			'notZero',
			value => {
				return value != 0;
			},
			'NOTZEROVALUE'
		);
		return {
			fields: [
				{
					name: 'identifier',
					label: 'LOGINFORM.IDENTIFIER',
					rules: 'required|string|between:3,50',
				},
				{
					name: 'applicationTitle',
					label: 'LOGINFORM.NAME',
					rules: 'required|string|between:3,50',
				},
				{
					name: 'email',
					label: 'LOGINFORM.EMAIL',
					rules: '',
				},
				{
					name: 'cutoffTime',
					label: 'ORGANIZATION.ADDITIONALINFO.CUTOFFTIME',
					rules: 'required|time',
				},
				{
					name: 'acceptingReturns',
					label: 'ORGANIZATION.ADDITIONALINFO.ACCEPTINGRETURNS',
					type: 'checkbox',
				},
				{
					name: 'enableEmailNotification',
					type: 'checkbox',
					label: 'ORGANIZATION.ADDITIONALINFO.ENABLEEMAILNOTIFICATION',
				},
				{
					name: 'inventoryLevel',
					label: 'ORGANIZATION.INVENTORYLEVEL',
					rules: 'required',
				},
				{
					name: 'preferredLtlCarrier',
					label: 'ORGANIZATION.ADDITIONALINFO.PREFERREDLTLCARRIER',
				},
				{
					name: 'facilityId',
					label: 'ORGANIZATION.CREDENTIALS.FACILITYID',
				},
				{
					name: 'userLoginId',
					label: 'ORGANIZATION.CREDENTIALS.USERLOGINID',
				},
				{
					name: 'clientId',
					label: 'ORGANIZATION.CREDENTIALS.CLIENTID',
				},
				{
					name: 'clientSecret',
					label: 'ORGANIZATION.CREDENTIALS.CLIENTSECRET',
				},
				{
					name: 'allowSaturdayShipping',
					label: 'ORGANIZATION.ADDITIONALINFO.ALLOWSATURDAYSHIPPING',
					type: 'checkbox',
				},
				{
					name: 'sendOrderAPI',
					label: 'ORGANIZATION.ADDITIONALINFO.SENDORDERAPI',
					type: 'checkbox',
				},
				{
					name: 'sendInventoryAPI',
					label: 'ORGANIZATION.ADDITIONALINFO.SENDINVENTORYAPI',
					type: 'checkbox',
				},
				{
					name: 'sendTransferAPI',
					label: 'ORGANIZATION.ADDITIONALINFO.SENDTRANSFERAPI',
					type: 'checkbox',
				},
				{
					name: 'warehouseNotificationRecipient',
					label: 'ORGANIZATION.CONTACT.WAREHOUSENOTIFICATIONRECIPIENT',
				},
				{
					name: 'address',
					fields: [
						{
							name: 'address1',
							label: 'ORGANIZATION.ADDRESS.ADDRESS1',
							rules: 'required|string',
						},
						{
							name: 'address2',
							label: 'ORGANIZATION.ADDRESS.ADDRESS2',
						},
						{
							name: 'address3',
							label: 'ORGANIZATION.ADDRESS.ADDRESS3',
						},
						{
							name: 'city',
							label: 'ORGANIZATION.ADDRESS.CITY',
							rules: 'required|string',
						},
						{
							name: 'zipCode',
							label: 'ORGANIZATION.ADDRESS.ZIPCODE',
							rules: 'required',
						},
					],
				},
				{
					name: 'contact',
					fields: [
						{
							name: 'email1',
							label: 'ORGANIZATION.CONTACT.EMAIL1',
							rules: 'required|email',
						},
						{
							name: 'email2',
							label: 'ORGANIZATION.CONTACT.EMAIL2',
							rules: 'email',
						},
						{
							name: 'phone1',
							label: 'ORGANIZATION.CONTACT.PHONE1',
							rules: 'required|string|phone',
						},
						{
							name: 'phone2',
							label: 'ORGANIZATION.CONTACT.PHONE2',
							rules: 'string|phone',
						},
					],
				},
				{
					name: 'warehouseStatusId',
					label: 'ORGANIZATION.ADDITIONALINFO.WAREHOUSESTATUS',
					rules: 'required',
				},
				{
					name: 'countryId',
					label: 'ORGANIZATION.ADDRESS.COUNTRY',
					rules: 'required',
				},
				{
					name: 'stateId',
					label: 'ORGANIZATION.ADDRESS.STATE',
					rules: 'required',
				},
				{
					name: 'timezoneId',
					label: 'ORGANIZATION.ADDRESS.TIMEZONE',
					rules: 'required',
				},
				{
					name: 'password',
					label: 'LOGINFORM.PASSWORD',
					rules: '',
					type: 'password',
				},
				{
					name: 'confirmPassword',
					label: 'LOGINFORM.CONFIRMPASSWORD',
					rules: '',
					type: 'password',
				},
				{
					name: 'apiKey',
					label: 'LOGINFORM.APIKEYEXTERNAL',
				},
				{
					name: 'warehouseOrganizationInfo',
					fields: [
						{
							name: 'warehouseId',
							label: 'ORGANIZATION.WAREHOUSEMANAGEMENT.WAREHOUSEID',
						},
						{
							name: 'dbName',
							label: 'ORGANIZATION.WAREHOUSEMANAGEMENT.DBNAME',
						},
						{
							name: 'subdomain',
							label: 'ORGANIZATION.WAREHOUSEMANAGEMENT.SUBDOMAIN',
						},
						{
							name: 'licenseId',
							label: 'ORGANIZATION.WAREHOUSEMANAGEMENT.LICENSEID',
						},
						{
							name: 'userName',
							label: 'ORGANIZATION.WAREHOUSEMANAGEMENT.USERNAME',
						},
						{
							name: 'password',
							label: 'ORGANIZATION.WAREHOUSEMANAGEMENT.PASSWORD',
						},
						{
							name: 'facilityId',
							label: 'ORGANIZATION.WAREHOUSEMANAGEMENT.FACILITYID',
						},
						{
							name: 'userLoginId',
							label: 'ORGANIZATION.WAREHOUSEMANAGEMENT.USERLOGINID',
						},
						{
							name: 'warehouseManagementTypeId',
							label: 'ORGANIZATION.WAREHOUSEMANAGEMENT.WAREHOUSEMANAGEMENTTYPE',
						},
					],
				},
			],
		};
	}
}
